import _ from 'lodash';
import {
  createFetchReviewsUrl,
  createReviewServerHeaders,
  createReviewsRequestParams,
  COUNTRY,
  REVIEWS_DEALER_ENDPOINT,
} from './fetch-helpers';
import { ReviewsApiConfig } from '../typings/reviews';
import { DealerReview } from '../typings/dealer-review';

interface FetchDealerDataOptions {
  reviewsHostData?: ReviewsApiConfig;
  readonly apiKeyContent?: string;
  readonly dealerId?: string;
  readonly dataVersion: string;
}

export class ReviewsDealerDataFetchError extends Error {
  public constructor(message: string) {
    super('FetchDealerDataError: ' + message);
  }
}

export async function fetchDealerData({
  reviewsHostData,
  apiKeyContent,
  dealerId,
  dataVersion

}: FetchDealerDataOptions): Promise<DealerReview> {
  if (!reviewsHostData)
  throw new ReviewsDealerDataFetchError('Host url is undefined');
if (!dealerId) throw new ReviewsDealerDataFetchError('Dealer Id is undefined');
if (!dataVersion) {
  throw new ReviewsDealerDataFetchError('Data version is undefined');
}
const reviewsParams = createReviewsRequestParams(
  dataVersion,
  undefined,
  undefined,
  undefined,
  undefined,
  undefined, COUNTRY );
  const { apiEnvironmentKey } = reviewsHostData?.customConfig as any;
  const requestHeader = createReviewServerHeaders(
    apiKeyContent || apiEnvironmentKey,
  );

  const reviewsRequestUrl = createFetchReviewsUrl(
    reviewsHostData,
    'commentsDealerPath',
    reviewsParams,
    REVIEWS_DEALER_ENDPOINT,
    dealerId
  );
  const request = await fetch(reviewsRequestUrl, { headers: requestHeader });
  const response = await request.json();

  if (request.status >= 500)
    throw new ReviewsDealerDataFetchError(response.message);
  if (!response || response.statusCode === 404)
    throw new ReviewsDealerDataFetchError(
      'Invalid response structure, NO CURRENT DEALER DATA',
    );

  return response;
}
